import { render, staticRenderFns } from "./PoomsaeAdmin.vue?vue&type=template&id=2eb564ef&scoped=true&"
import script from "./PoomsaeAdmin.vue?vue&type=script&lang=js&"
export * from "./PoomsaeAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PoomsaeAdmin.vue?vue&type=style&index=0&id=2eb564ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb564ef",
  null
  
)

export default component.exports